// extracted by mini-css-extract-plugin
export var errorIcon = "_ld-1";
export var nameLogo = "_ld-0";